import axios from '@/axios'

export default {
    namespaced: true,

    state: {

    },

    getters: {

    },

    mutations: {

    },

    actions: {
        async storeHash() {
            let { data } = await axios.get('admin/hashmanager')

            return data
        }
    }
}